module.exports = __webpack_public_path__ + "img/header-weddingRingsFacettedConnections.f95cc15.webp";